import { render, staticRenderFns } from "./workflow-builder.vue?vue&type=template&id=796b6a6e&"
import script from "./workflow-builder.component.ts?vue&type=script&lang=ts&"
export * from "./workflow-builder.component.ts?vue&type=script&lang=ts&"
import style0 from "./workflow-builder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\opusb-web-myactio\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('796b6a6e')) {
      api.createRecord('796b6a6e', component.options)
    } else {
      api.reload('796b6a6e', component.options)
    }
    module.hot.accept("./workflow-builder.vue?vue&type=template&id=796b6a6e&", function () {
      api.rerender('796b6a6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/core/application-dictionary/components/PopupForm/WorkflowBuilder/workflow-builder.vue"
export default component.exports